export default "__VITE_ASSET__d1a6cd29__"